import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import SelectForm from './SelectForm';
import Header from '../../../common/Header';
import Popup from '../../../common/Popup';
import PopupTrigger from '../../../common/PopupTrigger';

import { useRequest } from '../../../../hooks';
import { TYPE } from '../../../../constant';
import { ProgressLearningTebs, ProgressList } from '../common';
import { mathematicsListAPI } from '../../../../api/progressLearningAPI';
import { mathpidLogAPICall } from '../../../../redux/logData';
import { useDispatch } from 'react-redux';

function Mathematics() {
  const { t } = useTranslation();
  const logDispatch = useDispatch();
  const [alertMsg, setAlertMsg] = useState('');
  const [listCall, list] = useRequest((data) => mathematicsListAPI(data));

  useEffect(() => {
    console.log("***** 진도학습 - 교과수학 진도")

    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',
      screenCode: 'scr_0001_0001',
    }));
  }, [])

  const onSearch = (data) => {
    let msg = "";
    if (!data.eduCursCd) msg = "학년학기를 선택하세요.";
    else if (!data.unitCd) msg = "단원을 선택하세요.";

    if (msg) {
      setAlertMsg(msg);
      return;
    }
    listCall(data);
  }

  const alertMsgInitial = () => setAlertMsg("");

  return (
    <React.Fragment>
      <Header
        title={t("LC_06_01.msg001")}
      />
      <div className="layout-def tab-wrap layout-sl layout-my bg_gray2">
        <ProgressLearningTebs />
        <div className="container h_auto">
          <div className="inner">
           <div className="tabCont active" id="tabCont2">
              <SelectForm
                onSearch={onSearch}
              />
              <ProgressList
                list={list}
                learningEntryType={TYPE.LEARNING_ENTRY.SBJTMATH}
                noMsg="학년학기/단원을 선택해 주세요."
              />
            </div>
          </div>
        </div>
      </div>
      {
        alertMsg && (
          <PopupTrigger>
            <Popup buttonLabel={["확인"]}  onConfirm={alertMsgInitial}>
              <p className="lc-alert_txt m-fw-normal">
                {alertMsg}
              </p>
            </Popup>
          </PopupTrigger>
        )
      }
    </React.Fragment>
  );
}

export default Mathematics;